import { registerSystemAdminTab } from "routes/sfg20-admin/plugins/system-tab/register-system-admin-tab"
import { Lazy } from "lib/make-lazy"
import { AuditAccordionSummary, AuditTopBarDownloadButton } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { AccordionSummary, Typography } from "@mui/material"
import { Frag } from "lib/@components/slot/frag"
import { hasDemand } from "lib/authorization/has-demand"
import { AI_CONFIG_AUDIT_TYPE } from "library/ai/ai-configuration-constants.mjs"
import {
    PRIORITY_CONFIGURATION,
    SECTION_CONFIGURATION,
} from "routes/sfg20-admin/plugins/system-tab/system-admin-sections"

AuditAccordionSummary(AI_CONFIG_AUDIT_TYPE).plug(
    replaceAllWith(
        <AccordionSummary sx={{ pointerEvents: "none" }}>
            <Typography variant={"subtitle1"}>Model Configuration Changes</Typography>
        </AccordionSummary>
    )
)
AuditTopBarDownloadButton(AI_CONFIG_AUDIT_TYPE).plug(replaceAllWith(<Frag />))

registerSystemAdminTab(
    "AI Model Configuration",
    <Lazy importer={() => import("./components/ai-model-config-tab.js")} extract="AiModelConfigTab" />,
    () => hasDemand("admin"),
    PRIORITY_CONFIGURATION + 30,
    "mdi:robot-outline",
    SECTION_CONFIGURATION
)
